import * as React from 'react';
export const resourceSharingSvg = React.forwardRef(
  function resourceSharingSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M4 2.25A2.25 2.25 0 0 1 6.25 0h7.5A2.25 2.25 0 0 1 16 2.25v4a2.25 2.25 0 0 1-2.25 2.25H9A.75.75 0 0 1 9 7h4.75a.75.75 0 0 0 .75-.75V4.5H7A.75.75 0 0 1 7 3h7.5v-.75a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v.54a.75.75 0 1 1-1.5 0v-.54ZM3.25 7.5c0-.687.563-1.25 1.25-1.25s1.25.563 1.25 1.25-.563 1.25-1.25 1.25-1.25-.563-1.25-1.25ZM4.5 4.75A2.754 2.754 0 0 0 1.75 7.5a2.754 2.754 0 0 0 2.75 2.75A2.754 2.754 0 0 0 7.25 7.5 2.754 2.754 0 0 0 4.5 4.75Zm3 9.25v.5h-6V14A1.5 1.5 0 0 1 3 12.5h3A1.5 1.5 0 0 1 7.5 14Zm0 2h-6A1.5 1.5 0 0 1 0 14.5V14a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.5A1.5 1.5 0 0 1 7.5 16Z',
      }),
    );
  },
);
resourceSharingSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var resourceSharing = {
  category: 'icon',
  colorable: true,
  name: 'resourceSharing',
  svg: resourceSharingSvg,
};
